import { PART_BY_ID } from "./parts";
import { partIdForSpriteHue } from "./partSprites";

/** Maps removed legacy part ids to sprite-catalog equivalents. */
const LEGACY_PART_ID_MAP: Record<string, string> = {
  "nose-basic": partIdForSpriteHue("nose_cone", "blue"),
  "nose-sparkle": partIdForSpriteHue("nose_dome", "violet"),
  "nose-ruby": partIdForSpriteHue("nose_cone", "red"),
  "nose-gold": partIdForSpriteHue("nose_dome", "yellow"),
  "nose-ice": partIdForSpriteHue("nose_window_cone", "blue"),
  "nose-emerald": partIdForSpriteHue("nose_cone", "green"),
  "nose-sunset": partIdForSpriteHue("nose_dome", "orange"),
  "nose-midnight": partIdForSpriteHue("nose_dome", "indigo"),
  "nose-stellar": partIdForSpriteHue("nose_window_antenna", "violet"),

  "body-basic": partIdForSpriteHue("body_window", "blue"),
  "body-striped": partIdForSpriteHue("body_neon", "red"),
  "body-crimson": partIdForSpriteHue("body_window", "red"),
  "body-lavender": partIdForSpriteHue("body_neon", "violet"),
  "body-charcoal": partIdForSpriteHue("body_window", "indigo"),
  "body-candy": partIdForSpriteHue("body_neon", "red"),
  "body-nebula": partIdForSpriteHue("body_neon", "violet"),
  "body-lemon": partIdForSpriteHue("body_neon", "yellow"),
  "body-mint": partIdForSpriteHue("body_neon", "green"),

  "engine-basic": partIdForSpriteHue("engine_twin", "blue"),
  "engine-twin": partIdForSpriteHue("engine_twin", "yellow"),
  "engine-green": partIdForSpriteHue("engine_large", "green"),
  "engine-purple": partIdForSpriteHue("engine_triple", "violet"),
  "engine-gold": partIdForSpriteHue("engine_window_large", "yellow"),
  "engine-mega": partIdForSpriteHue("engine_large", "red"),
  "engine-nova": partIdForSpriteHue("engine_triple", "orange"),
  "engine-blue": partIdForSpriteHue("engine_twin", "blue"),
  "engine-red": partIdForSpriteHue("engine_triple", "red"),

  "fin-basic": partIdForSpriteHue("fin_chunky", "blue"),
  "fin-red": partIdForSpriteHue("fin_chunky", "red"),
  "fin-green": partIdForSpriteHue("fin_stripe", "green"),
  "fin-yellow": partIdForSpriteHue("fin_chunky", "yellow"),
  "fin-purple": partIdForSpriteHue("fin_stripe", "violet"),
  "fin-orange": partIdForSpriteHue("fin_chunky", "orange"),
  "fin-pink": partIdForSpriteHue("fin_metal", "red"),
  "fin-comet": partIdForSpriteHue("fin_stripe", "blue"),
  "fin-charcoal": partIdForSpriteHue("fin_metal", "indigo"),

  "booster-basic": partIdForSpriteHue("body_window", "orange"),
  "booster-big": partIdForSpriteHue("body_triple_window", "red"),
  "booster-slim": partIdForSpriteHue("body_neon", "red"),
  "booster-red": partIdForSpriteHue("body_neon", "red"),
  "booster-blue": partIdForSpriteHue("body_neon", "blue"),
  "booster-lime": partIdForSpriteHue("body_neon", "green"),
  "booster-violet": partIdForSpriteHue("body_neon", "violet"),
  "booster-turbo": partIdForSpriteHue("engine_large", "red"),
  "booster-mini": partIdForSpriteHue("engine_twin", "red"),
  "booster-orbit": partIdForSpriteHue("body_triple_window", "violet"),

  "window-round": partIdForSpriteHue("body_window", "blue"),
  "window-gold": partIdForSpriteHue("nose_window_dome", "yellow"),
  "window-teal": partIdForSpriteHue("body_window", "green"),
  "window-sky": partIdForSpriteHue("nose_window_cone", "blue"),
  "window-pink": partIdForSpriteHue("nose_window_cone", "red"),
  "window-lime": partIdForSpriteHue("body_neon", "green"),
  "window-amber": partIdForSpriteHue("nose_window_dome", "orange"),
  "window-coral": partIdForSpriteHue("body_neon", "orange"),
  "window-silver": partIdForSpriteHue("body_window", "blue"),
  "window-galaxy": partIdForSpriteHue("nose_window_antenna", "indigo"),
};

export function migratePartId(partId: string): string {
  if (PART_BY_ID[partId]) return partId;
  if (partId.startsWith("body_glow-")) {
    return partIdForSpriteHue("body_neon", partId.slice("body_glow-".length));
  }
  return LEGACY_PART_ID_MAP[partId] ?? partId;
}

export function migrateUnlockedPartIds(partIds: string[]): string[] {
  return [...new Set(partIds.map(migratePartId).filter((id) => Boolean(PART_BY_ID[id])))];
}
